import store from '@/store';
import randomColor from '@/shared/utils/random-color';
import { newEvent } from '@/shared/utils/notification-title';
import { webRTCAcceptCall } from '@/weon/web-rtc/WeonWebRTC.js';
import { SET_JOB_CHANNEL } from '@/store/mutation-types.js';
import i18n from '@/i18n';

export default class ManualDialerEvent {
  constructor(body) {
    if (body.success) {
      const styleLog =
        'color: #3949AB; font-weight: bold; background-color: #FFF59D;';
      console.group('%c ManualDialerEvent: ', styleLog);
      console.log(
        '%c [event]',
        'color: #F44336;',
        JSON.stringify(body, null, 4),
      );

      body.color = randomColor();
      body.voiceCampaign = body.campaignId;
      body.activeAttendance = true;
      body.callType = 'MANUAL';
      body.channel = 'voice';
      body.disabled = false;
      body.history = [];
      body.tab = {
        active: 0,
        tab: 'script',
      };

      store.dispatch('jobs/newVoice', body);
      newEvent();

      if (
        store.state.attendance.Attendance.agentAckCall &&
        store.state.attendance.Attendance.useWebRTC === 'Y'
      ) {
        webRTCAcceptCall();
      }

      store.commit(`jobs/${SET_JOB_CHANNEL}`, 'voice');
    } else {
      store.dispatch(
        'showSnackbar',
        { text: 'cannotCallToContact', type: 'error' },
        { root: true },
      );
    }
  }
}
